export default "__VITE_ASSET__553ffc1a__"